import { getDb } from './db';
export async function getSyncCursor() {
    const db = await getDb();
    const entry = await db.get('sync_meta', 'cursor');
    return entry?.data ?? 0;
}
export async function setSyncCursor(cursor) {
    const db = await getDb();
    await db.put('sync_meta', { key: 'cursor', data: cursor });
}
export async function getLastSyncTime() {
    const db = await getDb();
    const entry = await db.get('sync_meta', 'lastSyncTime');
    return entry?.data ?? null;
}
export async function setLastSyncTime(time) {
    const db = await getDb();
    await db.put('sync_meta', { key: 'lastSyncTime', data: time });
}
export async function getServerDeviceId() {
    const db = await getDb();
    const entry = await db.get('sync_meta', 'serverDeviceId');
    return entry?.data ?? null;
}
export async function setServerDeviceId(id) {
    const db = await getDb();
    await db.put('sync_meta', { key: 'serverDeviceId', data: id });
}
